import React from 'react';

const Fallback = () => <div>!!!!Fallback!!!</div>;

export default (Fallback);
